(() => {
	const productInfoArray = window.productInfoArray || [];

  let selectedType = null;
  let selectedSize = null;
  let selectedColor = null;
	let selectedSizeLabel = null;
	let modelImage = null;
	let modelUrl = '';
	let modelCompareAtPrice = '';
	let modelPrice = '';
	let typeHTML = '';

	var ArticlePopupOverlayFunc = (() => {
		let initialize = () => {
			console.log('Here is the popup button event---------');
			var overlay = document.getElementById('sales-landing-model-selector-modal');
	
			if (overlay) {
				var open = () => {
					overlay.classList.add('is-open');
					overlay.setAttribute('aria-hidden', 'false');
				}
	
				var close = () => {
					console.log("close event");
					overlay.classList.remove('is-open');
					overlay.setAttribute('aria-hidden', 'true');

					resetState();
				}
	
				// Open on button click
				document.querySelectorAll('.slpss-button').forEach((element) => {
					console.log("This is the open button");
					element.addEventListener('click', (e) => {
						e.preventDefault();
						open();
						document.querySelector('.slms-box-container.step-1')?.classList.remove('hidden');
					})
				})
	
				// Close on close button click
				// if (closeBtn) {
				// 	closeBtn.addEventListener('click', close);
				// }
	
				// Close on overlay background click
				overlay.addEventListener('click', e => {
					console.log("close event", overlay, e.target);

					if (e.target.classList.contains("mask") && e.target.classList.contains("close")) close();
				})
	
				// Close on Escape key
				document.addEventListener('keydown', e => {
					if (e.key === 'Escape') close();
				})
			}
		}
		return {
			init: initialize
		}
	})();
	var ProductColorSelectFunc = () => {
		console.log("here is the product color selection function ----------");
		document.querySelectorAll('[js-color-container] [js-product-color-option]').forEach(element => {
			element.addEventListener('click', () => {
				element.closest('[js-color-container]').querySelectorAll('[js-product-color-option]').forEach(subelement => {
					subelement.classList.remove('active');
				});
				element.classList.add('active');
				selectedColor = element.getAttribute('product-color-label');

				element.closest('[js-color-container]').querySelectorAll('[js-product-featured-image]').forEach(image => {
					if (image.getAttribute('js-product-featured-image') === element.getAttribute('js-product-color-option')) {
						image.classList.remove('d-none');
					} else {
						image.classList.add('d-none');
					}
				});

				document.getElementById('step3Next').classList.remove("disabled");
			});
		});
  }

	var typeSelectFunc = () => {
			document.querySelectorAll(".slms-type-card").forEach(ele => {
				ele.addEventListener("click", () => {
					document.querySelectorAll(".slms-type-card").forEach(element => {
						element.classList.remove("selected");
					});
					ele.classList.add("selected");
					document.getElementById('step1Next').classList.remove("disabled");

					console.log("product type", ele.getAttribute("product_type"));
					selectedType = ele.getAttribute("product_type");

					document.querySelectorAll('.slms-size-card').forEach(el => {
						el.classList.remove('selected');
						el.classList.remove("disabled");
					});

					if (selectedType.toLowerCase() == "cottage") {
						console.log("this is the type select function");
						document.querySelectorAll(".slms-size-card").forEach(ele => {
							let sizeLabel = ele.getAttribute("product_size_label");
							
							if (sizeLabel.toLowerCase() == "large") {
								console.log("this is the large type select function......");
								ele.classList.add("disabled");
							}
						});
					}
				});
			});
	}

	var sizeSelectFunc = () => {
		console.log("----------------------------------size select function");
		document.querySelectorAll(".slms-size-card").forEach(ele => {
			ele.addEventListener("click", () => {
				document.querySelectorAll(".slms-size-card").forEach(element => {
					element.classList.remove("selected");
				});
				ele.classList.add("selected");
				document.getElementById('step2Next').classList.remove("disabled");

				console.log("product type", ele.getAttribute("product_size"));
				selectedSize = ele.getAttribute("product_size");
				selectedSizeLabel = ele.getAttribute("product_size_label");

				console.log("this is the typeHTmL", selectedType);
				if (!selectedSizeLabel) return;
				if (selectedSizeLabel.toLowerCase() == "small") {
					typeHTML = `
						${selectedType} 25
					`;
				} else if (selectedSizeLabel.toLowerCase() == "medium") {
					typeHTML = `
						${selectedType} 28
					`;
				} else {
					typeHTML = `
						${selectedType} 40
					`;
				}
			});
		});
	}

	let goStep = (className) => {
		document.querySelectorAll(".slms-box-container").forEach((ele) => {
			ele.classList.add('hidden');
		});
		document.querySelector(`.slms-box-container.${className}`)?.classList.remove('hidden');
	} 

  let resetState = () => {
		document.querySelectorAll(".slms-box-container").forEach((ele) => {
			ele.classList.add('hidden');
		});
    selectedType = selectedSize = selectedColor = null;
		document.getElementById('step1Next').classList.add("disabled");
		document.getElementById('step2Next').classList.add("disabled");
		document.getElementById('step3Next').classList.add("disabled");
    document.querySelectorAll('.slms-type-card, .slms-size-card').forEach(el => {
			el.classList.remove('selected');
			el.classList.remove("disabled");
		});
		document.querySelectorAll('.slms-product-colors .color').forEach(el => el.classList.remove('active'));

		selectedSizeLabel = null;
		modelImage = null;
		modelUrl = '';
		modelCompareAtPrice = '';
		modelPrice = '';
		typeHTML = '';
  }
	
	ProductColorSelectFunc();
	typeSelectFunc();
	sizeSelectFunc();

	document.getElementById("step1Next")?.addEventListener("click", () => {
		goStep("step-2");
		
		let is_canGoNext = false;
		document.querySelectorAll(".slms-size-card").forEach(element => {
			if (element.classList.contains("selected")) {
				is_canGoNext = true;
			}
		});
		console.log("This is the canGoNext flag", is_canGoNext);
		if (is_canGoNext) document.getElementById('step2Next').classList.remove("disabled");
		else document.getElementById('step2Next').classList.add("disabled");
	});

	document.getElementById("step2Back")?.addEventListener("click", () => goStep("step-1"));
	document.getElementById("step2Next")?.addEventListener("click", () => {
		if (selectedType == "cube") document.querySelector('.slms-product-color-cube')?.classList.remove("hidden");
		else document.querySelector('.slms-product-color-cottage')?.classList.remove("hidden");

		goStep("step-3");
	});
	
	document.getElementById("step3Back")?.addEventListener("click", () => goStep("step-2"));
	document.getElementById("step3Next")?.addEventListener("click", () => {
		console.log("here is the before 4 statement");
		for (let i = 0; i < productInfoArray.length; i ++) {
			let productInfo = productInfoArray[i];

			console.log("comparison------", productInfo);
			console.log(selectedType.toLowerCase(), productInfo.type_label.toLowerCase());
			console.log(selectedSizeLabel, productInfo.size_label );
			console.log(selectedColor, productInfo.color);
			if (selectedType.toLowerCase() == productInfo.type_label.toLowerCase() 
				&& selectedSizeLabel == productInfo.size_label 
				&& selectedColor == productInfo.color) 
			{
				console.log("This is the selected product................", productInfo);
				modelImage = productInfo.image;
				modelUrl = productInfo.url;
				modelCompareAtPrice = productInfo.compare_at_price;
				modelPrice = productInfo.price;
			}
		}

		const productImageEle = document.querySelector('.slms-product-image-last-step');
		const productTypeEle = document.querySelector('.slms-product-type');
		const productCompareAtPriceEle = document.querySelector('.slms-product-compare-price');
		const productPriceEle = document.querySelector('.slms-product-current-price');
		const productColorIconEle = document.querySelector('.slms-product-color-icon');
		const productColorLabelEle = document.querySelector('.slms-product-color-label');
		const productSizeLabelEle = document.querySelector('.slms-product-size-label');
		const stepResultBtn = document.getElementById('stepResult');

		const modelColorSvg = document.querySelector(".slms-product-colors .color.active");
		if (productImageEle && productTypeEle && productCompareAtPriceEle && productPriceEle 
				&& productColorIconEle && productColorLabelEle && productSizeLabelEle && modelColorSvg) 
		{
			console.log("Here is the model view function -----------");
			let imageHTML = `
				<a href="${modelUrl}">
					<img src="${modelImage}" alt="Model Image" />
				</a>
			`;
			productImageEle.insertAdjacentHTML("afterbegin", imageHTML);
			stepResultBtn.setAttribute('href', modelUrl);
			console.log("this is the image -----------", imageHTML);

			console.log("typeHTLMl", typeHTML);
			productTypeEle.innerHTML = typeHTML;
			// productTypeEle.insertAdjacentHTML("afterbegin", typeHTML);

			productCompareAtPriceEle.innerHTML = modelCompareAtPrice;
			productPriceEle.innerHTML = modelPrice;
			productColorIconEle.innerHTML = modelColorSvg.innerHTML;
			productColorLabelEle.innerHTML = selectedColor;
			productSizeLabelEle.innerHTML = selectedSize;

			// productCompareAtPriceEle.insertAdjacentHTML("afterbegin", modelCompareAtPrice);
			// productPriceEle.insertAdjacentHTML("afterbegin", modelPrice);
			// productColorIconEle.insertAdjacentHTML("afterbegin", modelColorSvg.innerHTML);
			// productColorLabelEle.insertAdjacentHTML("afterbegin", selectedColor);
			// productSizeLabelEle.insertAdjacentHTML("afterbegin", selectedSize);
		}

		goStep("step-result");
	});

	document.addEventListener("DOMContentLoaded", () => {
		ArticlePopupOverlayFunc.init();

		const lastProductImage = document.querySelector(".slms-product-image-last-step a");
		if (lastProductImage) lastProductImage.removeAttribute("href");

		const productImages = document.querySelectorAll(".slms-product-image-list-cottage a");
		productImages.forEach((image) => {
			image.removeAttribute("href");
		});
	})

	console.log("this is the selected product info", selectedType, selectedSize, selectedColor);
})();
